module.exports = __webpack_public_path__ + "static/media/bg_trial_resumption_from_40_to_44.3a855db8.webp";